import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';

import LayoutLocationDetails from 'bento-ordering/menus/components/LayoutLocationDetails';
import useOnlineOrderingLocationInformation from 'hooks/useOnlineOrderingLocationInformation';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { getSectionNavColor } from 'styles/helpers/getThemeStyles';

const Details = styled('div')(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    marginTop: '64px',
    textAlign: 'left',
    flexGrow: 2
  },
  [theme.breakpoints.down('md')]: {
    marginTop: '21px'
  }
}));

const DetailsWithLogo = styled(Details)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    marginLeft: '16px'
  }
}));

const Header = styled(Typography)(({ theme }) => ({
  color: getSectionNavColor(theme),
  fontSize: '22px',
  marginBottom: 3,
  [theme.breakpoints.up('md')]: {
    marginRight: '24px',
    marginTop: '45px'
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '20px'
  }
}));

const HeaderWithLocationDescription = styled(Header)(({ theme }) => ({
  fontSize: '36px',
  [theme.breakpoints.up('md')]: {
    marginTop: '35px'
  }
}));

function LogoFocusedLocationInformation({
  hasLogo,
  hasLocationDescription,
  name,
  showLocationInformation
}) {
  const locationInformation = useOnlineOrderingLocationInformation();
  if (!locationInformation) {
    return null;
  }

  const InformationWrapper = hasLogo ? DetailsWithLogo : Details;
  const HeaderComponent = hasLocationDescription
    ? HeaderWithLocationDescription
    : Header;

  return (
    <InformationWrapper>
      <HeaderComponent variant={ITEM_DESCRIPTION_AND_PRICES}>
        {name}
      </HeaderComponent>
      {showLocationInformation && (
        <LayoutLocationDetails {...locationInformation} />
      )}
    </InformationWrapper>
  );
}

LogoFocusedLocationInformation.propTypes = {
  hasLogo: PropTypes.bool.isRequired,
  hasLocationDescription: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  showLocationInformation: PropTypes.bool.isRequired
};

export default LogoFocusedLocationInformation;
